module.exports = __webpack_public_path__ + "static/media/eTicket.d93b5194.svg";